<template>
  <div>
    <b-modal
      v-model="modalShow"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <h4 style="color: red">
          <b> {{ title }}</b>
        </h4>
        <p>{{ description }}</p>
        <p class="m-0">{{ $t("expiry-modals.contactStore") }}</p>
        <!-- <button class="expiry-close-btn mt-3" @click="close">{{$t('expiry-modals.ok')}}</button> -->
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    show: Boolean,
    title: String,
    description: String,
  },
  data() {
    return {
      modalShow: false,
    };
  },
  watch: {
    show: {
      handler(val) {
        this.modalShow = val;
      },
    },
  },
  methods: {
    close() {
      this.$emit(`closeIframe`);
    },
  },
};
</script>
<style scoped>
.expiry-close-btn {
  padding: 10px 50px;
  border: 2px solid #5559fe;

  background: #3d6ddb;
  color: #fff;
  border-radius: 7px;
}
</style>
